export default __webpack_public_path__ + "static/bubbles-c1b3fe50a7b6b3b1e0489f8cd068c8da.png";